import axios from "axios";
import toast from "react-hot-toast";
import { API_BASE_URL_V2, SERVICES_API } from "../constants";
import ToastError from "../common/ToastError";

export const apiCallV2 = (method, url, reqData, headers, params, cache = true) => {
	const changeStatus = () => { };
	window.addEventListener("online", () => changeStatus());

	window.addEventListener("offline", () => changeStatus());
	return axios({
		method: method,
		url: API_BASE_URL_V2 + url,
		data: reqData,
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Accept": "application/json",
			"Content-Type": "application/json",
			"access-token": headers,
			"Cache-Control": "no-cache",
		},
		params: cache ? params : {
			...params,
			t: new Date().getTime()
		},
	})
		.then((response) => {
			return response;
		})
		.catch(async (error) => {
			const platform = localStorage.getItem("indi-platform");
			axios({
				method: "POST",
				url: API_BASE_URL_V2 + "error-log/new",
				data: {
					platform: (platform == "null" || !platform) ? "web" : platform,
					location: "INDI-APP-api-call",
					error: JSON.stringify(error)
				},
				headers: {
					"Access-Control-Allow-Origin": "*",
					"Accept": "application/json",
					"Content-Type": "application/json",
					"access-token": localStorage.getItem("access-token") || localStorage.getItem("temp-access-token"),
					"Cache-Control": "no-cache",
				}
			})

			if (
				typeof error != "undefined" &&
				typeof error?.response != "undefined" &&
				error?.response?.status === 401
			) {
				toast.error("Unauthorized error");
				// return error?.response;
			} else if (
				typeof error != "undefined" &&
				typeof error?.response != "undefined" &&
				error?.response?.status === 500
			) {
				toast.error(ToastError);
				return error?.response;
			} else if (
				error?.response?.status === 409
			) { // EMAIL USED
				toast.error(error?.response?.data);
				return error?.response;
			} else if (
				error?.response?.status === 406
			) { // EMAIL USED
				if (error?.response?.data?.message) {
					let message = error?.response?.data?.message?.replace("Token", "Card Details");
					toast.error(message);
				} else {
					toast.error(ToastError);
				}
				return error?.response;
			} else {
				return error?.response;
			}
		});
};

export const servicesAPICall = (method, url, reqData, headers, params, cache = true) => {
	const changeStatus = () => { };
	window.addEventListener("online", () => changeStatus());

	window.addEventListener("offline", () => changeStatus());
	return axios({
		method: method,
		url: SERVICES_API + url,
		data: reqData,
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Accept": "application/json",
			"Content-Type": "application/json",
			"access-token": headers,
			"Cache-Control": "no-cache",
		},
		params: cache ? params : {
			...params,
			t: new Date().getTime()
		},
	})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			const platform = localStorage.getItem("indi-platform");
			axios({
				method: "POST",
				url: API_BASE_URL_V2 + "error-log/new",
				data: {
					platform: (platform == "null" || !platform) ? "web" : platform,
					location: "INDI-APP-servcie-api-call",
					error: JSON.stringify(error)
				},
				headers: {
					"Access-Control-Allow-Origin": "*",
					"Accept": "application/json",
					"Content-Type": "application/json",
					"access-token": localStorage.getItem("access-token") || localStorage.getItem("temp-access-token"),
					"Cache-Control": "no-cache",
				}
			})
			if (
				typeof error != "undefined" &&
				typeof error?.response != "undefined" &&
				error?.response?.status === 401
			) {
				toast.error("Unauthorized error");
				// return error?.response;
			} else if (
				typeof error != "undefined" &&
				typeof error?.response != "undefined" &&
				error?.response?.status === 500
			) {
				toast.error(ToastError);
				return error?.response;
			} else if (
				error?.response?.status === 409
			) { // EMAIL USED
				toast.error(error?.response?.data);
				return error?.response;
			} else {
				return error?.response;
			}
		});
};